import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { SEO } from "@/components/SEO";
import HeroSection from "@/components/landing/HeroSection";
import StatsHighlightSection from "@/components/landing/StatsHighlightSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import ToolDemosSection from "@/components/landing/ToolDemosSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import ComparisonSection from "@/components/landing/ComparisonSection";
import ROICalculatorSection from "@/components/landing/ROICalculatorSection";
import SocialProofSection from "@/components/landing/SocialProofSection";
import FAQSection from "@/components/landing/FAQSection";
import CTASection from "@/components/landing/CTASection";

const Index = () => {
  return (
    <div className="min-h-screen bg-white selection:bg-accent/10 selection:text-accent">
      <SEO
        title="AI-Powered Hiring Platform"
        description="Screen, interview, and hire top talent with Intellr. Voice-based screening, automated scheduling, and smart candidate matching."
        url="https://intellr.io"
        keywords="AI hiring, candidate screening, voice interviews, job matching, talent acquisition"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Intellr",
          "url": "https://intellr.io",
          "logo": "https://intellr.io/intellr-logo.png",
          "description": "AI-powered hiring platform for screening, interviewing, and hiring top talent.",
          "sameAs": ["https://linkedin.com/company/intellr"]
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <StatsHighlightSection />
        <FeaturesSection />
        <ToolDemosSection />
        <HowItWorksSection />
        <ComparisonSection />
        <ROICalculatorSection />
        <SocialProofSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
